import type { FormConfig } from '#types/config/components/vf/form'

export default {
  brandClasses: {
    container: 'flex gap-1',
    icon: 'mt-0.5'
  },
  showIcon: true
} satisfies FormConfig['error']
